import Logger from '@/logger'
import CookieConsentManager from '@/cookie-consent-manager'

import LocalStorageGateway from './local/local-storage-gateway'
import Store from '@/store'
import { MUTATIONS } from '@/store/mutations'

import GuestContext from '@/auth/guest-context'

const guestLocal = new LocalStorageGateway(new GuestContext())
const sessionStore = new LocalStorageGateway(new GuestContext(), true)

/**
 * Helper functions to use across storage access points.
 */
const StorageHelper = {

    /**
     * Gets the storage interfaces for the appropriate context.
     *
     * @param {Context} authContext
     * @returns {LocalStorageGateway}
     */
    getLocalStore(authContext) {
        return authContext && authContext.type === 'account'
            ? new LocalStorageGateway(authContext)
            : StorageHelper.guestLocal
    },

    /**
     * Resets all the elements of Vuex state for the app.
     *
     * @param {Boolean} keepProperty - Set to true to keep the property selection
     */
    resetAllVuexState(keepProperty = false) {
        Store.commit(keepProperty ? MUTATIONS.resetNonPropertyBaseState : MUTATIONS.resetNonContextState)
        Store.commit(MUTATIONS.MYHOME.resetState)
        Store.commit(MUTATIONS.IMPROVEMENTS.resetState)
    },

    /**
     * Indicates if storage is disabled.
     *
     * @async
     * @returns {Promise<boolean>} True if storage is disabled.
     */
    async storageDisabledAsync() {
        const cookieConsent = await CookieConsentManager.getConsentDataAsync()

        if (!cookieConsent.appCore) {
            Logger.log('Local Storage is disabled', 'Local Storage')
            return true
        }

        return false
    },

    guestLocal,
    sessionStore,
}

export default StorageHelper
